// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__31sP4","upload":"Small_upload__XETvz","imageWrap":"Small_imageWrap__10lYa","removeBtn":"Small_removeBtn__2Uziy"};